<div class="fea-application-container">
<app-navbar></app-navbar>
  <div class="form-header">
    <h1>Female Engineering Academy</h1>
    <h2>Application Form</h2>
    <p class="tagline">Join our program and transform your future in engineering</p>
  </div>

  <form [formGroup]="applicationForm" (ngSubmit)="submitApplication()" class="application-form">
    <div *ngIf="submitting" class="submitting-overlay" aria-live="polite">
      <div class="d-flex align-items-center">
        <strong>Submitting...</strong>
        <div class="spinner-border ms-2" role="status" aria-hidden="true"></div>
      </div>
    </div>
    <fieldset [disabled]="submitting">
    <!-- SECTION 1: PERSONAL INFORMATION -->
    <div class="form-section">
      <h3 class="section-title">Personal Information</h3>
      
      <div class="form-group">
        <label for="fullName" class="form-label">Full Name <span class="required">*</span></label>
        <input 
          type="text" 
          id="fullName" 
          formControlName="fullName" 
          class="form-control"
          placeholder="Enter your full name"
          required>
        <div class="error-message" *ngIf="isFieldInvalid('fullName')">
          Full name is required
        </div>
      </div>

      <div class="form-row">
        <div class="form-group form-group-half">
          <label for="dateOfBirth" class="form-label">Date of Birth <span class="required">*</span></label>
          <input 
            type="date" 
            id="dateOfBirth" 
            formControlName="dateOfBirth" 
            class="form-control"
            required>
          <div class="error-message" *ngIf="isFieldInvalid('dateOfBirth')">
            Date of birth is required
          </div>
        </div>

        <div class="form-group form-group-half">
          <label for="email" class="form-label">Email Address <span class="required">*</span></label>
          <input 
            type="email" 
            id="email" 
            formControlName="email" 
            class="form-control"
            placeholder="your.email@example.com"
            required>
          <div class="error-message" *ngIf="isFieldInvalid('email')">
            Valid email is required
          </div>
        </div>
      </div>
    
      <div class="form-row">
        <div class="form-group form-group-half">
          <label for="email" class="form-label">Phone Number <span class="required">*</span></label>
          <input 
            type="tel" 
            id="phone" 
            formControlName="phone" 
            class="form-control"
            placeholder="your phone number"
            required>
          <div class="error-message" *ngIf="isFieldInvalid('phone')">
            Valid phone number is required
          </div>
      </div>
      <div class="form-group form-group-half">
        <label for="city" class="form-label">City/Town <span class="required">*</span></label>
        <input 
          type="text" 
          id="city" 
          formControlName="city" 
          class="form-control"
          placeholder="Your city or town"
          required>
        <div class="error-message" *ngIf="isFieldInvalid('city')">
          City/Town is required
        </div>
      </div>
    </div>  
    </div>

    <!-- SECTION 2: EDUCATIONAL BACKGROUND -->
    <div class="form-section">
      <h3 class="section-title">Educational Background</h3>

      <div class="form-group">
        <label for="education" class="form-label">Highest Level of Education Completed <span class="required">*</span></label>
        <select 
          id="education" 
          formControlName="education" 
          class="form-control"
          required>
          <option value="" disabled selected>Select an option</option>
          <option value="SHS">SHS (Senior High School)</option>
          <option value="Diploma">Diploma</option>
          <option value="HND">HND (Higher National Diploma)</option>
          <option value="Bachelor">Bachelor's Degree</option>
          <option value="Other">Other</option>
        </select>
        <div class="error-message" *ngIf="isFieldInvalid('education')">
          Education level is required
        </div>
      </div>

      <div class="form-group">
        <label for="fieldOfStudy" class="form-label">Field of Study <span class="required">*</span></label>
        <input 
          type="text" 
          id="fieldOfStudy" 
          formControlName="fieldOfStudy" 
          class="form-control"
          placeholder="e.g., Mathematics, Physics, Electrical Studies"
          required>
        <div class="error-message" *ngIf="isFieldInvalid('fieldOfStudy')">
          Field of study is required
        </div>
      </div>
    </div>

    <!-- SECTION 3: MOTIVATION & INTERESTS -->
    <div class="form-section">
      <h3 class="section-title">Motivation & Interests</h3>

      <div class="form-group">
        <label for="whyInterested" class="form-label">Why are you interested in Mechanical or Electrical Engineering? <span class="required">*</span></label>
        <textarea 
          id="whyInterested" 
          formControlName="whyInterested" 
          class="form-control"
          rows="4"
          placeholder="Tell us about your interest in engineering..."
          required></textarea>
        <div class="error-message" *ngIf="isFieldInvalid('whyInterested')">
          This field is required
        </div>
      </div>

      <div class="form-group">
        <label class="form-label">Do you have any prior technical or engineering experience? <span class="required">*</span></label>
        <div class="radio-group">
          <div class="radio-item">
            <input 
              type="radio" 
              id="expYes" 
              name="technicalExperience" 
              value="Yes"
              formControlName="technicalExperience"
              required>
            <label for="expYes" class="radio-label">Yes</label>
          </div>
          <div class="radio-item">
            <input 
              type="radio" 
              id="expNo" 
              name="technicalExperience" 
              value="No"
              formControlName="technicalExperience"
              required>
            <label for="expNo" class="radio-label">No</label>
          </div>
        </div>
        <div class="error-message" *ngIf="isFieldInvalid('technicalExperience')">
          This field is required
        </div>
      </div>

      <div class="form-group">
        <label class="form-label">Which track are you most interested in? <span class="required">*</span></label>
        <div class="radio-group">
          <div class="radio-item">
            <input 
              type="radio" 
              id="trackMech" 
              name="trackInterest" 
              value="Mechanical Engineering"
              formControlName="trackInterest"
              required>
            <label for="trackMech" class="radio-label">Mechanical Engineering</label>
          </div>
          <div class="radio-item">
            <input 
              type="radio" 
              id="trackElec" 
              name="trackInterest" 
              value="Electrical Engineering"
              formControlName="trackInterest"
              required>
            <label for="trackElec" class="radio-label">Electrical Engineering</label>
          </div>
          <div class="radio-item">
            <input 
              type="radio" 
              id="trackOther" 
              name="trackInterest" 
              value="Other"
              formControlName="trackInterest"
              required>
            <label for="trackOther" class="radio-label">Other</label>
          </div>
        </div>
        <div class="error-message" *ngIf="isFieldInvalid('trackInterest')">
          This field is required
        </div>
      </div>

      <div class="form-group">
        <label for="problemSolve" class="form-label">What problem in your community would you like to solve using engineering skills? <span class="required">*</span></label>
        <textarea 
          id="problemSolve" 
          formControlName="problemSolve" 
          class="form-control"
          rows="4"
          placeholder="Describe a specific problem you want to solve..."
          required></textarea>
        <div class="error-message" *ngIf="isFieldInvalid('problemSolve')">
          This field is required
        </div>
      </div>
    </div>

    <!-- SECTION 4: COMMITMENT & CIRCUMSTANCES -->
    <div class="form-section">
      <h3 class="section-title">Commitment & Circumstances</h3>

      <div class="form-group">
        <label class="form-label">Are you currently employed or in school? <span class="required">*</span></label>
        <div class="radio-group">
          <div class="radio-item">
            <input 
              type="radio" 
              id="statusEmp" 
              name="employmentStatus" 
              value="Employed"
              formControlName="employmentStatus"
              required>
            <label for="statusEmp" class="radio-label">Employed</label>
          </div>
          <div class="radio-item">
            <input 
              type="radio" 
              id="statusSelfEmp" 
              name="employmentStatus" 
              value="Self-employed"
              formControlName="employmentStatus"
              required>
            <label for="statusSelfEmp" class="radio-label">Self-employed</label>
          </div>
          <div class="radio-item">
            <input 
              type="radio" 
              id="statusStudent" 
              name="employmentStatus" 
              value="Student"
              formControlName="employmentStatus"
              required>
            <label for="statusStudent" class="radio-label">Student</label>
          </div>
          <div class="radio-item">
            <input 
              type="radio" 
              id="statusUnemployed" 
              name="employmentStatus" 
              value="Unemployed"
              formControlName="employmentStatus"
              required>
            <label for="statusUnemployed" class="radio-label">Unemployed</label>
          </div>
        </div>
        <div class="error-message" *ngIf="isFieldInvalid('employmentStatus')">
          This field is required
        </div>
      </div>

      <div class="form-group">
        <label class="form-label">If selected, can you fully commit to attending all training sessions? <span class="required">*</span></label>
        <div class="radio-group">
          <div class="radio-item">
            <input 
              type="radio" 
              id="commitYes" 
              name="fullCommitment" 
              value="Yes"
              formControlName="fullCommitment"
              required>
            <label for="commitYes" class="radio-label">Yes</label>
          </div>
          <div class="radio-item">
            <input 
              type="radio" 
              id="commitNo" 
              name="fullCommitment" 
              value="No"
              formControlName="fullCommitment"
              required>
            <label for="commitNo" class="radio-label">No</label>
          </div>
          <div class="radio-item">
            <input 
              type="radio" 
              id="commitMaybe" 
              name="fullCommitment" 
              value="Maybe"
              formControlName="fullCommitment"
              required>
            <label for="commitMaybe" class="radio-label">Maybe</label>
          </div>
        </div>
        <div class="error-message" *ngIf="isFieldInvalid('fullCommitment')">
          This field is required
        </div>
      </div>

      <div class="form-group">
        <label for="challenges" class="form-label">What challenges might prevent you from completing this program? <span class="required">*</span></label>
        <textarea 
          id="challenges" 
          formControlName="challenges" 
          class="form-control"
          rows="4"
          placeholder="Describe any challenges you might face..."
          required></textarea>
        <div class="error-message" *ngIf="isFieldInvalid('challenges')">
          This field is required
        </div>
      </div>

      <div class="form-group">
        <label for="overcomeChallenges" class="form-label">How do you plan to overcome these challenges? <span class="required">*</span></label>
        <textarea 
          id="overcomeChallenges" 
          formControlName="overcomeChallenges" 
          class="form-control"
          rows="4"
          placeholder="Explain your strategy to overcome challenges..."
          required></textarea>
        <div class="error-message" *ngIf="isFieldInvalid('overcomeChallenges')">
          This field is required
        </div>
      </div>
    </div>

    <!-- SECTION 5: DISCIPLINE & AGREEMENT -->
    <div class="form-section">
      <h3 class="section-title">Discipline & Agreement</h3>

      <div class="form-group">
        <label class="form-label">Are you willing to follow strict discipline, punctuality, and safety rules? <span class="required">*</span></label>
        <div class="radio-group">
          <div class="radio-item">
            <input 
              type="radio" 
              id="disciplineYes" 
              name="disciplineWilling" 
              value="Yes"
              formControlName="disciplineWilling"
              required>
            <label for="disciplineYes" class="radio-label">Yes</label>
          </div>
          <div class="radio-item">
            <input 
              type="radio" 
              id="disciplineNo" 
              name="disciplineWilling" 
              value="No"
              formControlName="disciplineWilling"
              required>
            <label for="disciplineNo" class="radio-label">No</label>
          </div>
        </div>
        <div class="error-message" *ngIf="isFieldInvalid('disciplineWilling')">
          This field is required
        </div>
      </div>

      <div class="form-group">
        <label for="whySelect" class="form-label">Why should we select you over other applicants? <span class="required">*</span></label>
        <textarea 
          id="whySelect" 
          formControlName="whySelect" 
          class="form-control"
          rows="4"
          placeholder="Tell us what makes you a great candidate..."
          required></textarea>
        <div class="error-message" *ngIf="isFieldInvalid('whySelect')">
          This field is required
        </div>
      </div>

      <div class="form-group">
        <label class="form-label">If selected, are you willing to sign a commitment agreement to complete the 6-month program? <span class="required">*</span></label>
        <div class="radio-group">
          <div class="radio-item">
            <input 
              type="radio"
              id="agreementYes" 
              name="commitmentAgreement" 
              value="Yes"
              formControlName="commitmentAgreement"
              required>
            <label for="agreementYes" class="radio-label">Yes</label>
          </div>
          <div class="radio-item">
            <input 
              type="radio" 
              id="agreementNo" 
              name="commitmentAgreement" 
              value="No"
              formControlName="commitmentAgreement"
              required>
            <label for="agreementNo" class="radio-label">No</label>
          </div>
        </div>
        <div class="error-message" *ngIf="isFieldInvalid('commitmentAgreement')">
          This field is required
        </div>
      </div>

      <div class="form-group checkbox-group">
        <div class="checkbox-item">
          <input 
            type="checkbox" 
            id="confirmInfo" 
            formControlName="confirmInfo"
            required>
          <label for="confirmInfo" class="checkbox-label">
            I confirm that all information provided is true and accurate. <span class="required">*</span>
          </label>
        </div>
        <div class="error-message" *ngIf="isFieldInvalid('confirmInfo')">
          You must confirm the information is accurate
        </div>
      </div>
    </div>

    <!-- FORM ACTIONS -->
    <div class="form-actions">
      <button 
        type="reset" 
        class="btn btn-secondary"
        (click)="resetForm()">
        Clear Form
      </button>
      <button 
        type="submit" 
        class="btn btn-primary"
        [disabled]="submitting || !applicationForm.valid">
        <span class="fa fa-paper-plane me-2"></span>
        Submit Application
      </button>
    </div>
    </fieldset>
  </form>

  <!-- Success Message -->
  <div class="success-message" *ngIf="formSubmitted">
    <div class="alert alert-success">
      <h4>Application Submitted Successfully!</h4>
      <p>Thank you for your interest in the Female Engineering Academy. We will review your application and contact you shortly.</p>
    </div>
  </div>
</div>
